export default __webpack_public_path__ + "74932b3a76559baf9c21b8057fe80131.woff";